import clsx from "clsx";
import type { ComponentProps } from "react";

import s from "./sticky-card.module.scss";

export type CompProps = ComponentProps<"div"> & {
  className?: string;
  isOpen: boolean;
  children: React.ReactNode;
  viewButton?: boolean;
};

export const StickyCard = (props: CompProps) => {
  const { className, children, isOpen, viewButton } = props;

  return (
    <div
      className={clsx(s.root, className, {
        [s.open]: isOpen,
        [s.viewButton]: viewButton,
      })}
    >
      {children}
    </div>
  );
};

StickyCard.displayName = "StickyCard";
